import { formatDate } from '../../services/date-utils';
import { BewerbungDto } from '../dto/bewerber.dto';
import { Bewerber, FileDocument } from '../../models/bewerber.model';
import { BewerbungUnterlagen } from '../../models/unterlagen.model';
import { toAusbildungDto, toBerufserfahrungDto, toBildDto, toEhrenamtDto } from './unterlagen.mapper';

export function mapToDto(bewerber: Bewerber, unterlagen: BewerbungUnterlagen, dokumente: FileDocument[]): BewerbungDto {
  return {
    interessent: {
      vorname: bewerber.vorname,
      rufname: bewerber.rufname,
      nachname: bewerber.nachname,
      geburtsdatum: formatDate(bewerber.geburtsdatum),
      geburtsname: bewerber.geburtsname,
      geschlecht: bewerber.geschlecht,
      email: bewerber.email,
      hausnummer: bewerber.hausnummer,
      nationalitaet: bewerber.nationalitaet,
      plz: bewerber.plz,
      stadt: bewerber.stadt,
      strasse: bewerber.strasse,
      telefonMobil: bewerber.telefonMobil,
      telefonPrivat: bewerber.telefonPrivat,
      bewerbungsunterlagen: {
        bild: unterlagen.bild !== null ? toBildDto(unterlagen.bild) : null,
        ausbildung: unterlagen.ausbildung.map(toAusbildungDto),
        berufserfahrung: unterlagen.berufserfahrung.map(toBerufserfahrungDto),
        ehrenamt: unterlagen.ehrenamt.map(toEhrenamtDto),
        sonstiges: unterlagen.sonstiges !== null ? unterlagen.sonstiges.replace(/\r?\n/g, '<br />') : null,
        motivation: unterlagen.motivation.replace(/\r?\n/g, '<br />')
      }
    },
    dokumente
  };
}
